export default "__VITE_ASSET__omreiBj6__"